import { CtaLink, Paragraph } from '@purpurds/purpur';
import { TeliaHeading } from '@teliads/components/react';
import './BusinessContentCard.scss';
import { useTranslation } from 'react-i18next';

import { Dimensions, createMultipleSizeImages } from 'utils/utils';

type ContentBannerProps = {
  title: string;
  preamble: string;
  cta: { text?: string; url?: string };
  image: { url: string; altText: string; focusArea: string };
  isReversedImagePosition?: boolean;
  isDividerActive?: boolean;
};

const BusinessContentCard = ({ title, preamble, cta, image }: ContentBannerProps) => {
  const contentBannerDimensions: Dimensions = {
    small: ['3:2', 650],
    medium: ['3:2', 850],
    large: ['3:2', 1280],
  };

  const imageSizes = createMultipleSizeImages(
    {
      url: image.url,
      altText: image.altText,
      focusArea: image.focusArea,
    },
    contentBannerDimensions
  );

  const { t } = useTranslation();

  return (
    <div className="business-content-card__wrapper">
      <section className="business-content-card">
        <div className="business-content-card__image-container">
          <img
            src={image.url ? imageSizes.medium : '/image/purple-900.png'}
            className="business-content-card__image"
            alt={image.altText}
          />
        </div>
        <div className="business-content-card__text-container">
          <div className="text-container__title-category-wrapper">
            {false && (
              <Paragraph className="text-container__category" variant="overline-100">
                CATEGORY
              </Paragraph>
            )}
            <TeliaHeading tag="h2" variant="title-200" className="business-content-card__title">
              {title}
            </TeliaHeading>
          </div>
          {preamble && (
            <Paragraph className="business-content-card__preamble">{preamble || ''}</Paragraph>
          )}
          {cta?.url && (
            <div className="business-content-card__cta">
              <CtaLink icon="forward" variant="secondary" href={cta?.url || undefined}>
                {cta?.text || t('read_more')}
              </CtaLink>
            </div>
          )}
        </div>
      </section>
    </div>
  );
};

export default BusinessContentCard;
